const BULLETIN_CATEGORIES = {
    BRAND_AMBASSADOR: 1,
    CHARITY: 2,
    COLLECTIVE_OPT_IN: 3,
    CONTENT_CREATION: 4,
    DIGITAL_ASSETS: 5,
    EMPLOYMENT_INTERNSHIPS: 6,
    GENERAL: 7,
    GROUP_LICENSING: 8,
    MERCHANDISE_AUTOGRAPHS: 9,
    PUBLIC_APPEARANCE: 10,
    EVENT_EXPERIENCE: 11,
    EARNED_MEDIA: 12,
    ENTERTAINMENT: 13,
    INFLUENCER: 14,
    IN_MARKET_APPEARANCE: 15,
    NASCAR_CONTENT: 16,
    FOUNDATION_HOF: 17,
    INDUSTRY_EVENT: 18,
    BROADCAST: 19,
    PARTNERSHIP: 20,
    IMPACT: 21,
    BRAND: 22,
    DRIVER_SUBMISSION: 23,
};
const LEADERBOARD_ONLY_BULLETIN_CATEGORY_IDS = [11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
const BULLETIN_TYPES = {
    INFORMATIONAL: 1,
    OFFER: 2,
};
export { BULLETIN_CATEGORIES, BULLETIN_TYPES, LEADERBOARD_ONLY_BULLETIN_CATEGORY_IDS, };
